import React, { useContext, useState } from "react";
import { Button, Form, Input, message, Row, Col, Typography, Spin } from "antd";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import { request } from "../services/api";
import Bot from "../assets/Capi.png";
import Logo from "../assets/logo-full.png";

const { Title, Text } = Typography;

const Login = () => {
  const { login, setHasSettingsAccess, setUserSession } =
    useContext(AppContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const data = await request("/management/auth/login", {
        method: "POST",
        body: JSON.stringify({ pin: Number(values.pin) })
      });
      if (data) {
        setUserSession({
          name: data.name,
          lastname: data.lastname
        });
        if (data.role === "admin") {
          setHasSettingsAccess(true);
        } else {
          setHasSettingsAccess(false);
        }
        //localStorage.setItem("userToken", data.token); // Guardamos el token real
        login(); // Función del Contexto que ya teníamos
        messageApi.success("Bienvenido al sistema");
        navigate("/", { replace: true });
      }
    } catch (error) {
      messageApi.error("PIN inválido o error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {contextHolder}
      <Spin spinning={loading}>
        <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }}>
          <div className="login-card">
            <Row style={{ height: "100%" }}>
              {/* LEFT - FORM */}
              <Col xs={24} md={12} className="login-form-section">
                <img
                  style={{ width: 300, marginBottom: "40px" }}
                  src={Logo}
                  alt="light"
                />
                <Title
                  style={{ fontWeight: "bold", color: "#255B37" }}
                  level={2}
                >
                  Bienvenido
                </Title>
                <Text
                  style={{ marginBottom: "80px", color: "#64A70A" }}
                  type="secondary"
                >
                  Ingresa a la configuración de tu Bot
                </Text>

                <Form onFinish={onFinish} layout="vertical">
                  <div className="password-row">
                    <label className="label">Pin</label>
                  </div>
                  <Form.Item
                    name="pin"
                    rules={[
                      {
                        required: true,
                        len: 8,
                        message: "El PIN debe tener 8 dígitos"
                      }
                    ]}
                  >
                    <Input.Password
                      placeholder="12345678"
                      maxLength={8}
                      size="large"
                    />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" block size="large">
                    Ingresar
                  </Button>
                </Form>
              </Col>
              {/* RIGHT - IMAGE */}
              <Col xs={0} md={12} className="login-image-section">
                <img src={Bot} alt="login" className="login-image" />
              </Col>
            </Row>
          </div>
        </motion.div>
      </Spin>
    </div>
  );
};
export default Login;
